import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
export class HeaderElement extends Component {

    drawSortButtons() {
        return (
            <div>
                <label>{this.props.title}</label>
                <div className="sortUp" onClick={() => this.props.setSort(true)} ></div>
                <div className="sortDown" onClick={() => this.props.setSort(false)} ></div>
            </div>
        )
    }

    render() {
        return (
            <Table.HeaderCell>
                <div>
                    {this.props.setSort && this.drawSortButtons()}
                </div>
            </Table.HeaderCell>
        );
    }
}

HeaderElement.propTypes = {
    title: PropTypes.string,
    setSort: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/components/TaskTable/RowHeadTable/HeaderElement/HeaderElement.js